import { z } from "zod";

/**
 * ReportFolhaPagamentoDetalhadaSchema
 */

export const ReportFolhaPagamentoDetalhadaSchema = z.object({
  folhaPagamentos: z.array(z.number()).nullable().default(null),
  centroCustos: z.array(z.number()).nullable().default(null),
  funcionarios: z.array(z.number()).nullable().default(null),
  cargos: z.array(z.number()).nullable().default(null),
  dataCadastroDe: z.date().nullable().default(null),
  dataCadastroAte: z.date().nullable().default(null),
  dataPagamentoDe: z.date().nullable().default(null),
  dataPagamentoAte: z.date().nullable().default(null),
});

/**
 * ReportFolhaPagamentoDetalhadaForm
 */

export type ReportFolhaPagamentoDetalhadaForm = z.infer<typeof ReportFolhaPagamentoDetalhadaSchema>;